// extracted by mini-css-extract-plugin
export default {"wrapper":"anchor-module--wrapper--afc13"};